import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-metodo-de-pago',
  templateUrl: './metodo-de-pago.component.html',
  styleUrls: ['./metodo-de-pago.component.scss'],
})
export class MetodoDePagoComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
